const CustomerPaymentMethodEnum = {
    Manual: 'Manual',
    Ach: 'Ach',
    Credit: 'Credit',
}

export default CustomerPaymentMethodEnum;